
// import { VueCropper } from "vue-cropper";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ResponsiveDialog from "./responsive-dialog.vue";
import DialogCloseBtn from "../common/dialog-close-btn.vue";
const MIN_ZOOM = 0;
const MAX_ZOOM = 200;
export default {
  components: {
    VueCropper,
    ResponsiveDialog,
    DialogCloseBtn
  },
  props: {
    dialog: true,
    photo: {},
    blob: false
  },
  computed: {},
  data() {
    return {
      MIN_ZOOM,
      MAX_ZOOM,
      option: {},
      zoomBy: 100,
      photoString: "",
      cropImg: "",
      data: null,
      imgType: "image/jpeg"
    };
  },
  async beforeMount() {
    this.photoString = await this.blobToBase64(this.photo);
    this.imgType = this.photo && this.photo.type;
    this.option = {
      img: this.photo,
      size: 1,
      outputType: "jpeg"
    };
  },
  methods: {
    photoCropped(e) {
      console.log(e);
    },
    async cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL(this.imgType);
      if (this.blob) {
        const croppedImageAsBlob = await this.dataUrlToFile(
          this.cropImg,
          this.photo.name
        );
        this.$emit("save", croppedImageAsBlob);
      } else {
        this.$emit("save", this.cropImg);
      }
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute("data-scale", scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoomIn() {
      this.zoomBy += 10;
      this.zoom();
    },
    zoomOut() {
      this.zoomBy -= 10;
      this.zoom();
    },
    zoom() {
      const ration = this.zoomBy / 100;
      this.$refs.cropper.zoomTo(ration);
      // this.$refs.cropper.relativeZoom(percent);
    }
  }
};
